import { orchestrator } from 'satcheljs';
import { onViewModeChanged } from '../actions/onViewModeChanged';
import { onViewModeChangedInternalMutator } from '../mutators/onViewModeChangedInternal';
import { saveCommandingViewModeOption } from 'owa-commanding-option';
import { ensureWin32IconsRegistered } from 'owa-command-ribbon-win32-icon';
import { type CommandingViewMode } from 'owa-outlook-service-option-store/lib/store/schema/options/CommandingOptions';
import isWin32StylingEnabled from 'owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled';

/* eslint-disable-next-line owa-custom-rules/forbid-orchestrator-in-same-package -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!
 *	> Do not register an orchestrator with an action that is defined in the same package */
orchestrator(onViewModeChanged, async actionMessage => {
    const { viewMode } = actionMessage;

    if (isWin32StylingEnabled()) {
        ensureWin32IconsRegistered(viewMode === 2);
    }

    // Update store
    onViewModeChangedInternalMutator(viewMode);

    // Update OWS'
    return saveCommandingViewModeOption(viewMode);
});
